"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IImageWithAnnotation = void 0;
var utils_1 = require("../../../utils");
exports.IImageWithAnnotation = (0, utils_1.IRecord)({
    image: (0, utils_1.IImage)(),
    bboxes: (0, utils_1.IList)(),
    paintObjects: (0, utils_1.IList)()
});
